__turbopack_context__.v({
  "galleryBtn": "tX-XVG_galleryBtn",
  "nav": "tX-XVG_nav",
  "navNext": "tX-XVG_navNext",
  "navPrev": "tX-XVG_navPrev",
  "pageArea": "tX-XVG_pageArea",
  "root": "tX-XVG_root",
});
